
/* eslint-disable max-len */
export type BorderRadiusDsToken = 'none' | 'atomic' | 'quarck' | 'tiny' | 'nano' | 'mini' | 'xxxs' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'circular';

export type BorderRadiusDsType = `var(--border-radius-${BorderRadiusDsToken})` |
  `var(--border-radius-${BorderRadiusDsToken}) var(--border-radius-${BorderRadiusDsToken})` |
  `var(--border-radius-${BorderRadiusDsToken}) var(--border-radius-${BorderRadiusDsToken}) var(--border-radius-${BorderRadiusDsToken})` |
  `var(--border-radius-${BorderRadiusDsToken}) var(--border-radius-${BorderRadiusDsToken}) var(--border-radius-${BorderRadiusDsToken}) var(--border-radius-${BorderRadiusDsToken})` |
  null | undefined;

export const SwipeBorderRadiusDs: BorderRadiusDsType = 'var(--border-radius-mini) var(--border-radius-mini) var(--border-radius-none) var(--border-radius-none)';
export const CircularBorderRadiusDs: BorderRadiusDsType = 'var(--border-radius-circular)';
export const NoneBorderRadiusDs: BorderRadiusDsType = 'var(--border-radius-none)';

